<template>
  <div class="v-home">
    <Header></Header>
    <div class="container v-home__content">
      <Navigation></Navigation>
      <div class="flex-row">
        <div class="flex-col">
          <Services></Services>
          <Dates></Dates>

          <Comment></Comment>
          <div class="flex-row flex-row--end">
            <router-link to="visit">
              <button class="btn btn--primary mb--3 v-brand__btn" :disabled="validation.service === false">
                Szukaj wolnego terminu
              </button>
            </router-link>
          </div>

        </div>
        <div class="flex-col flex-col--4 ml--3">
          <Summary></Summary>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/footer.vue'
import Header from '@/components/header.vue'
import Navigation from "@/components/navigation";

import Services from "@/components/services/services";
import Dates from "@/components/services/dates";
import Comment from "@/components/services/comment";
import Summary from "@/components/services/summary";

import lead from '../mixins/lead.js';

export default {
  name: 'home',
  mixins: [lead],
  components: {
    Footer,
    Header,
    Navigation,
    Services,
    Dates,
    Comment,
    Summary
  },
  mounted() {

    const script = document.createElement('script');
    script.src = 'https://trafficscanner.pl/ws2/script/3908/koniec.js';
    document.body.appendChild(script);
  }
}
</script>
<style lang="scss">
.v-home {
  &__content {
    min-height: 90vh;
  }
}
</style>
